import { useTranslation } from 'react-i18next';
import type { SeriesLookup } from './chartModel.js';

export function ChartDataTable({
  labels,
  series,
  format,
}: {
  labels: string[];
  series: SeriesLookup[];
  format: (n: number) => string;
}) {
  const { t } = useTranslation('agent');
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 'var(--s-2)' }}>
      <span style={{ fontSize: 'var(--fz-12)', fontWeight: 600, color: 'var(--fg-2)' }}>
        {t('artifacts.chart.dataTable')}
      </span>
      <div style={{ overflowX: 'auto' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 'var(--fz-12)' }}>
          <thead>
            <tr>
              <th style={TH_STYLE}>{t('artifacts.chart.category')}</th>
              {series.map((s) => (
                <th key={s.name} style={TH_NUMERIC_STYLE}>
                  {s.name}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {labels.map((label) => (
              <tr key={label}>
                <td style={TD_STYLE}>{label}</td>
                {series.map((s) => (
                  <td key={s.name} style={TD_NUMERIC_STYLE}>
                    {formatOptionalValue(s.values.get(label), format, t('artifacts.chart.noValue'))}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

const TH_STYLE = {
  padding: 'var(--s-2)',
  borderBottom: '1px solid var(--border-1)',
  color: 'var(--fg-2)',
  textAlign: 'left',
} as const;

const TH_NUMERIC_STYLE = {
  ...TH_STYLE,
  textAlign: 'right',
  fontVariantNumeric: 'tabular-nums',
} as const;

const TD_STYLE = {
  padding: 'var(--s-2)',
  borderBottom: '1px solid var(--border-2)',
  color: 'var(--fg-1)',
} as const;

const TD_NUMERIC_STYLE = {
  ...TD_STYLE,
  textAlign: 'right',
  fontVariantNumeric: 'tabular-nums',
} as const;

function formatOptionalValue(
  value: number | undefined,
  format: (n: number) => string,
  fallback: string,
): string {
  return value === undefined ? fallback : format(value);
}
